import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useSubjects(data = {}) {
  const { enabled = false, queryParams = '', configs = {} } = data;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  async function getSubjects() {
    return privateFetch.get(`/v1/admin/subject${queryParams}`, configs).then((res) => res.data);
  }

  return useQuery(['subjects', { data }], getSubjects, { enabled, keepPreviousData: true });
}

export default useSubjects;
